import React from "react"
import { Common } from "lib/types"
import { ReactComponent as CampaignIcon } from "images/icons/badge-percent.svg"
import { PermissionGroups } from "../constants"

import { Campaigns } from "views/Campaigns/Campaigns"
import { ShowCampaigns } from "views/Campaigns/ShowCampaigns"
import { CreateCampaign } from "views/Campaigns/CreateCampaign"
import { UpdateCampaignGroup } from "views/Campaigns/UpdateCampaignGroup"
import { UpdateCampaign } from "views/Campaigns/UpdateCampaign"
import { DuplicateCampaign } from "views/Campaigns/DuplicateCampaign"

export const campaignRoutes: Common.Views = [
  {
    element: <Campaigns />,
    path: "/campaigns",
    title: "Campaigns",
    icon: CampaignIcon,
    sortOrder: 3,
    requiredGroups: PermissionGroups.campaigns.read,
    configKey: "campaignEnabled",
    children: [
      {
        element: <ShowCampaigns />,
        path: "/campaigns/",
        title: "Show campaigns",
        parentPath: "/campaigns",
        section: "Campaigns"
      },
      {
        element: <CreateCampaign />,
        path: "/campaigns/create-campaign",
        title: "Create campaign",
        parentPath: "/campaigns",
        requiredGroups: PermissionGroups.campaigns.write
      },
      {
        element: <UpdateCampaignGroup />,
        path: "/campaigns/campaign-group/:id",
        title: "Campaigns",
        parentPath: "/campaigns"
      },
      {
        element: <DuplicateCampaign />,
        path: "/campaigns/duplicate-campaign/:id",
        title: "Duplicate campaign",
        parentPath: "/campaigns"
      },
      {
        element: <UpdateCampaign />,
        path: "/campaigns/campaign/:id",
        title: "Campaigns",
        parentPath: "/campaigns"
      }
    ]
  }
]
